// extracted by mini-css-extract-plugin
export var typingIndicator = "_qi-0";